import { render, staticRenderFns } from "./PushMessageRecord.vue?vue&type=template&id=031b73a6&scoped=true"
import script from "./PushMessageRecord.vue?vue&type=script&lang=js"
export * from "./PushMessageRecord.vue?vue&type=script&lang=js"
import style0 from "./PushMessageRecord.vue?vue&type=style&index=0&id=031b73a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b73a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031b73a6')) {
      api.createRecord('031b73a6', component.options)
    } else {
      api.reload('031b73a6', component.options)
    }
    module.hot.accept("./PushMessageRecord.vue?vue&type=template&id=031b73a6&scoped=true", function () {
      api.rerender('031b73a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/PushMessageRecord.vue"
export default component.exports